export const SERVICE_ID = 'service_pa2kuyk'
export const TEMPLATE_ID = 'template_6cis8zl'
export const PUBLIC_ID = 'MyIokncgGmgttbdZP'
export const APIKEY = '14a609f69f80d9d4b4acf737d445f03b'
export const MAX_UPLOAD = 32 * 1024 * 1024